import * as React from 'react';
import { PVADiamond } from '../../../components';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './PVANav.css';

interface PVANavProps {
    activeInd: number;
    groups: any[];
    stickyGroups: number[];
    sticky: boolean;
    style?: string;
    onSelect: Function;
    content?: any;
    FilterStore?: FilterStore;
    requireCharacteristics?: boolean;
}

@inject('FilterStore') @observer
export class PVANav extends React.Component<PVANavProps, {}> {
    constructor(props: PVANavProps) {
        super(props);
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    private getPastActive(initial: string, index: number) {
        var result: string = initial;
        var val = this.props.stickyGroups[index];
        switch (val) {
            case 0: {
                break;
            }
            case 1: {
                result += ' active';
                break;
            }
            case 2: {
                result += ' past';
                break;
            }
            default: {
                break;
            }
        }
        return result;
    }

    render() {
        var groups: any[] = this.props.groups.filter((groupData: any) => {
            if (!this.surveyReportType) {
                return true;
            }
            return this.surveyReportType.id === groupData.surveyReportTypeID;
        });
        
        return (
            <div className={'my-report-nav sticky-nav ' + (this.props.sticky ? 'sticky' : '')} >
                <div className="inner-stick">
                    <div className="sticky-content">
                        {this.props.content}
                    </div>
                    <div className="my-report-nav-inner">
                        <div className="icon-state">
                            <PVADiamond style={this.props.style} step={this.props.activeInd + 1} />
                        </div>

                        {this.props.groups &&
                            <div className={'remainder ' + (this.props.activeInd === (groups.length - 1) ? 'last' : '' )}>
                                {groups.filter((x: any) => {
                                    if (x.characteristicGroupDisplayType !== undefined && x.characteristicGroupDisplayType !== 'normal') {
                                        return false;
                                    }
                                    if (x.displayType !== undefined && x.displayType !== 'normal') {
                                        return false;
                                    }
                                    var hasData = (x.data && x.data.length > 0);
                                    var hasCGCs = (x.characteristicGroupCharacteristics && x.characteristicGroupCharacteristics.length > 0);
                                    var hasCGSGs = (x.characteristicGroupSubGroups && x.characteristicGroupSubGroups.length > 0);
                                    if (this.props.requireCharacteristics && (!hasData && !hasCGCs && !hasCGSGs)) {
                                        return false;
                                    }
                                    if (!this.surveyReportType) {
                                        return true;
                                    }
                                    return x.surveyReportTypeID === this.surveyReportType.id;
                                }).map((groupData: any, index: any) => {
                                    return <div key={`title-index-${index}`}>
                                        <a href={'#' + groupData.name} onClick={(e) => this.props.onSelect(e)} className={this.getPastActive('title', index)}>
                                            <div className="title-sub">{groupData.subtitle}</div>
                                            <span> {groupData.name} </span>
                                        </a>
                                        {
                                            (index !== groups.length - 1) &&
                                            <div className="seperator"><div className="contain"><div className={this.getPastActive('inner', index)} /></div></div>
                                        }
                                    </div>;
                                })}
                            </div>
                        }
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVANav.tsx